import { render, staticRenderFns } from "./TagTypeIndicator.vue?vue&type=template&id=ca1ce64a"
import script from "./TagTypeIndicator.vue?vue&type=script&lang=ts"
export * from "./TagTypeIndicator.vue?vue&type=script&lang=ts"
import style0 from "./TagTypeIndicator.vue?vue&type=style&index=0&id=ca1ce64a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports